module.exports = __webpack_public_path__ + "static/media/3.189f1a24.png";